// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"HomePage_Wrapper__3z0qm","SearchComponentWrapper":"HomePage_SearchComponentWrapper__1zF83"};